import { today } from '../../../helpers';
import i18n from '../../../helpers/lang/i18n';

export const inputsStep1 = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'typePolicieTransport',
      title: t('nueva_operacion.inputs_step_1.tipo_de_poliza'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
         },
      },
      cols: 6,
      placeholder: t('global.elije_una_opcion'),
      listenSelect: true,
      options: [
        { id: 1, nombre: 'Terrestre' },
        { id: 2, nombre: 'Maritimo' },
        { id: 3, nombre: 'Paqueteria' },
      ],
    },
    {
      key: 'email',
      title: t('global.email'),
      type: 'email',
      validations: {
        rules: {
          required: true,
          email: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
          email: t('global.email_invalido'),
         },
      },
      placeholder: t('global.email'),
      value: null,
      cols: 6,
    },
    {
      key: 'phone',
      title: t('global.telefono'),
      type: 'text',
      validations: {
        rules: {
          required: true,
          max: 12,
          min: 8,
        },
        messages: {
          required: t('global.es_obligatorio'),
         },
      },
      placeholder: t('global.telefono'),
      value: null,
      cols: 6,
    },
    {
      key: 'asset',
      title: t('nueva_operacion.inputs_step_1.tipo_de_mercancia_transportada'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      listenSelect: true,
      selectLabel: null,
      placeholder: t('global.elije_una_opcion'),
      value: null,
      cols: 6,
      options: [],
    },
    {
      key: 'subAsset',
      title: t('landing.components.form_home.sub_tipo_de_mercancia_transportada'),
      type: 'select',
      selectLabel: null,
      placeholder: t(
        'landing.components.form_home.sub_tipo_de_mercancia_transportada_placeholder',
      ),
      listenSelect: true,
      listenRemove: true,
      value: null,
      cols: 6,
      options: [],
      disabled: true,
      hidden: false,
    },
    {
      key: 'product',
      title: t('landing.components.form_home.producto'),
      type: 'select',
      validations: {
        rules: {
          required: false,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      selectLabel: null,
      placeholder: t('landing.components.form_home.producto_placeholder'),
      listenSelect: true,
      value: null,
      cols: 6,
      options: [],
      hidden: false,
      disabled: true,
      listenRemove: true,
    },
  ];
};

export const inputsStep2MX = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'rfc',
      title: t('nueva_operacion.inputs_step_2.rfc_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_2.rfc_del_cliente'),
      value: null,
      cols: 4,
      customClass: ' text-uppercase',
      hidden: false,
      formatValue: (e: string) => e?.toUpperCase() ?? '',
      errors: [],
    },
  ];
};

export const inputsStep2CL = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'rut',
      title: t('nueva_operacion.inputs_step_2.rut_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t(
        'nueva_operacion.inputs_step_2.rut_del_cliente_sin_guiones',
      ),
      value: null,
      cols: 12,
      customClass: 'w-25 text-uppercase',
      hidden: false,
      errors: [],
    },
  ];
};

export const inputsStep2AR = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'cuit',
      title: t('nueva_operacion.inputs_step_2.cuit_del_cliente'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t(
        'nueva_operacion.inputs_step_2.cuit_del_cliente_sin_guiones',
      ),
      value: null,
      cols: 4,
      customClass: 'text-uppercase',
      hidden: false,
      formatValue: (e: string) => e?.replace(/[^0-9]/g, '') ?? '',
      errors: [],
    },
  ];
};

export const inputsStep3MX = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'tradeName',
      title: t('nueva_operacion.inputs_step_3_mx.nombre_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_mx.nombre_del_cliente'),
      value: null,
      cols: 4,
      formatValue: (e: string) => e?.toUpperCase() ?? '',
    },
    {
      key: 'email',
      title: t('nueva_operacion.inputs_step_3_mx.email_del_cliente'),
      type: 'email',
      validations: {
        rules: {
          required: true,
          email: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
          email: t('global.email_invalido'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_mx.email_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'phone1',
      title: t('nueva_operacion.inputs_step_3_mx.telefono_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
          max: 12,
          min: 8,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_mx.telefono_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'companyGPSId',
      title: t('nueva_operacion.inputs_step_3_mx.empresa_gps'),
      selectLabel: null,
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_mx.empresa_gps'),
      value: null,
      cols: 4,
      options: [],
    },
    {
      key: 'address',
      title: t('nueva_operacion.inputs_step_3_mx.direccion_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_mx.direccion_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'postCode',
      title: t('nueva_operacion.inputs_step_3_mx.codigo_postal'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t(
        'nueva_operacion.inputs_step_3_mx.codigo_postal_placeholder',
      ),
      value: null,
      cols: 4,
      listenChange: true,
    },
    {
      key: 'colony',
      title: t('nueva_operacion.inputs_step_3_mx.colonia'),
      selectLabel: null,
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_mx.colonia'),
      value: null,
      cols: 4,
      options: [],
    },
    {
      key: 'city',
      title: t('nueva_operacion.inputs_step_3_mx.ciudad'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_3_mx.ciudad'),
      value: null,
      cols: 4,
      disabled: true,
    },
    {
      key: 'state',
      title: t('nueva_operacion.inputs_step_3_mx.estado'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_3_mx.estado'),
      value: null,
      cols: 4,
      disabled: true,
    },
  ];
};

export const inputsStep3CL = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'tradeName',
      title: t('nueva_operacion.inputs_step_3_cl.nombre_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_cl.nombre_del_cliente'),
      value: null,
      cols: 4,
      formatValue: (e: string) => e?.toUpperCase() ?? '',
    },
    {
      key: 'email',
      title: t('nueva_operacion.inputs_step_3_cl.nombre_del_cliente'),
      type: 'email',
      validations: {
        rules: {
          required: true,
          email: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
          email: t('global.email_invalido'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_cl.nombre_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'phone1',
      title: t('nueva_operacion.inputs_step_3_cl.nombre_del_cliente'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_3_cl.nombre_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'companyGPSId',
      title: t('nueva_operacion.inputs_step_3_cl.empresa_gps'),
      selectLabel: null,
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      disabled: false,
      placeholder: t('nueva_operacion.inputs_step_3_cl.empresa_gps'),
      value: null,
      cols: 4,
      options: [],
    },
    {
      key: 'address',
      title: t('nueva_operacion.inputs_step_3_cl.direccion_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_cl.direccion_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'postCode',
      title: t('nueva_operacion.inputs_step_3_cl.codigo_postal'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t(
        'nueva_operacion.inputs_step_3_cl.codigo_postal_placeholder',
      ),
      value: null,
      cols: 4,
    },
    {
      key: 'region',
      title: t('nueva_operacion.inputs_step_3_cl.region'),
      selectLabel: null,
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_cl.region'),
      value: null,
      cols: 4,
      options: [],
      listenSelect: true,
    },
    {
      key: 'comuna',
      title: t('nueva_operacion.inputs_step_3_cl.comuna'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_cl.comuna'),
      value: null,
      options: [],
      cols: 4,
    },
  ];
};

export const inputsStep3AR = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'tradeName',
      title: t('nueva_operacion.inputs_step_3_ar.nombre_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_ar.nombre_del_cliente'),
      value: null,
      cols: 4,
      formatValue: (e: string) => e?.toUpperCase() ?? '',
    },
    {
      key: 'email',
      title: t('nueva_operacion.inputs_step_3_ar.email_del_cliente'),
      type: 'email',
      validations: {
        rules: {
          required: true,
          email: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
          email: t('global.email_invalido'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_ar.email_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'phone1',
      title: t('nueva_operacion.inputs_step_3_ar.telefono_del_cliente'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_3_ar.telefono_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'companyGPSId',
      title: t('nueva_operacion.inputs_step_3_ar.empresa_gps'),
      selectLabel: null,
      type: 'select',
      disabled: false,
      placeholder: t('nueva_operacion.inputs_step_3_ar.empresa_gps'),
      value: null,
      cols: 4,
      options: [],
    },
    {
      key: 'address',
      title: t('nueva_operacion.inputs_step_3_ar.direccion_del_cliente'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_ar.direccion_del_cliente'),
      value: null,
      cols: 4,
    },
    {
      key: 'postCode',
      title: t('nueva_operacion.inputs_step_3_ar.codigo_postal'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t(
        'nueva_operacion.inputs_step_3_ar.codigo_postal_placeholder',
      ),
      value: null,
      cols: 4,
    },
    {
      key: 'province',
      title: t('nueva_operacion.inputs_step_3_ar.provincia'),
      selectLabel: null,
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_ar.provincia'),
      value: null,
      cols: 4,
      options: [],
      listenSelect: true,
    },
    {
      key: 'city',
      title: t('nueva_operacion.inputs_step_3_ar.localidad'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_3_ar.localidad'),
      value: null,
      options: [],
      cols: 4,
    },
  ];
};

export const inputsStep4MX = () => {
  const t = i18n.global.t;
  return [
    {
      key: 'assetId',
      title: t('nueva_operacion.inputs_step_4_mx.tipo_de_mercancia'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_mx.tipo_de_mercancia'),
      value: null,
      cols: 12,
      disabled: true,
    },
    {
      key: 'indemnificationLimit',
      title: t('nueva_operacion.inputs_step_4_mx.limite_de_indemnizacion'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t(
        'nueva_operacion.inputs_step_4_mx.limite_de_indemnizacion',
      ),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'indemnificationLimit-calc',
      title: t('nueva_operacion.inputs_step_4_mx.precio'),
      type: 'text',
      value: null,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_mx.precio_mas_iva'),
      disabled: true,
      cols: 6,
    },
    {
      key: 'sourceCityZipCodeId',
      title: t('nueva_operacion.inputs_step_4_mx.ciudad_de_origen'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_mx.codigo_postal'),
      value: null,
      cols: 6,
      listenChange: true,
    },
    {
      key: 'sourceCityZipCodeIdCalc',
      title: t('nueva_operacion.inputs_step_4_mx.ciudad_de_origen'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_mx.ciudad_de_origen'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'destinationCityZipCodeId',
      title: t('nueva_operacion.inputs_step_4_mx.ciudad_de_destino_final'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_mx.codigo_postal'),
      value: null,
      cols: 6,
      listenChange: true,
    },
    {
      key: 'destinationCityZipCodeIdCalc',
      title: t('nueva_operacion.inputs_step_4_mx.ciudad_de_destino_final'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t(
        'nueva_operacion.inputs_step_4_mx.ciudad_de_destino_final',
      ),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'stops',
      title: t('nueva_operacion.inputs_step_4_mx.paradas_intermedias'),
      selectLabel: null,
      type: 'select',
      placeholder: t(
        'nueva_operacion.inputs_step_4_mx.paradas_intermedias_placeholder',
      ),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      options: [
        { nombre: 'Si', id: 1 },
        { nombre: 'No', id: 0 },
      ],
      listenSelect: true,
    },
    {
      key: 'stop1',
      title: t('nueva_operacion.inputs_step_4_mx.parada_1'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.parada_1'),
      value: null,
      cols: 6,
      disabled: true,
      validations: {
        rules: {
          required: false,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'stop2',
      title: t('nueva_operacion.inputs_step_4_mx.parada_2'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.parada_2'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'stop3',
      title: t('nueva_operacion.inputs_step_4_mx.parada_3'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.parada_3'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'startDate',
      title: t('nueva_operacion.inputs_step_4_mx.fecha_inicio_viaje'),
      type: 'date',
      placeholder: t('nueva_operacion.inputs_step_4_mx.fecha_inicio_viaje'),
      value: null,
      cols: 6,
      min: today(),
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'startTime',
      title: t('nueva_operacion.inputs_step_4_mx.hora_inicio_viaje'),
      type: 'time',
      placeholder: t('nueva_operacion.inputs_step_4_mx.hora_inicio_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      listenFocus: true,
    },
    {
      key: 'endDate',
      title: t('nueva_operacion.inputs_step_4_mx.fecha_fin_viaje'),
      type: 'date',
      placeholder: t('nueva_operacion.inputs_step_4_mx.fecha_fin_viaje'),
      value: null,
      cols: 6,
      min: today(),
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'endTime',
      title: t('nueva_operacion.inputs_step_4_mx.hora_fin_viaje'),
      type: 'time',
      placeholder: t('nueva_operacion.inputs_step_4_mx.hora_fin_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'documentDescription',
      title: t('nueva_operacion.inputs_step_4_mx.documentos_del_viaje'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.documentos_del_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'document',
      title: t('nueva_operacion.inputs_step_4_mx.adjuntar_documentos'),
      type: 'file',
      placeholder: t('nueva_operacion.inputs_step_4_mx.adjuntar_documentos'),
      value: null,
      cols: 6,
      hidden: false,
    },
    {
      key: 'truckPlate',
      title: t('nueva_operacion.inputs_step_4_mx.placa_tractor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.placa_tractor'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'box-trailer',
      title: t('nueva_operacion.inputs_step_4_mx.caja_de_carga'),
      selectLabel: null,
      type: 'select',
      placeholder: t('nueva_operacion.inputs_step_4_mx.caja_de_carga'),
      value: null,
      cols: 4,
      options: [
        { nombre: 'Si', id: 1 },
        { nombre: 'No', id: 0 },
      ],
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      hidden: false,
      listenSelect: true,
    },
    {
      key: 'trailerPlate',
      title: t('nueva_operacion.inputs_step_4_mx.placa_caja'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.placa_caja'),
      value: null,
      cols: 4,

      validations: {
        rules: {
          required: false,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      disabled: true,
    },
    {
      key: 'driverName',
      title: t('nueva_operacion.inputs_step_4_mx.nombre_del_conductor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.nombre_del_conductor'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'driverCellphone',
      title: t('nueva_operacion.inputs_step_4_mx.movil_del_conductor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_mx.movil_del_conductor'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          required: true,
          max: 12,
          min: 8,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'driverEmail',
      title: t('nueva_operacion.inputs_step_4_mx.email_del_conductor'),
      type: 'email',
      placeholder: t('nueva_operacion.inputs_step_4_mx.email_del_conductor'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          email: true,
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      hidden: false,
    },
  ];
};

export const inputsStep4AR = () => {
  const t = i18n.global.t;

  return [
    {
      key: 'typeOfMerchandise',
      title: t('nueva_operacion.inputs_step_4_ar.tipo_de_mercancia'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_ar.tipo_de_mercancia'),
      value: null,
      cols: 12,
      disabled: true,
    },
    {
      key: 'indemnificationLimit',
      title: t('nueva_operacion.inputs_step_4_ar.limite_de_indemnizacion'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_ar.limite_de_indemnizacion'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'indemnificationLimit-calc',
      title: t('nueva_operacion.inputs_step_4_ar.precio'),
      type: 'text',
      value: null,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_ar.precio_mas_iva'),
      disabled: true,
      cols: 6,
    },
    {
      key: 'originProvince',
      title: t('nueva_operacion.inputs_step_4_ar.provincia_de_origen'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      options: [],
      placeholder: t('nueva_operacion.inputs_step_4_ar.provincia_de_origen'),
      value: null,
      cols: 6,
      listenSelect: true,
    },
    {
      key: 'originCity',
      title: t('nueva_operacion.inputs_step_4_ar.localidad_de_origen'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_ar.localidad_de_origen'),
      value: null,
      cols: 6,
      options: [],
      disabled: true,
    },
    {
      key: 'destinationProvince',
      title: t('nueva_operacion.inputs_step_4_ar.provincia_de_destino_final'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_ar.provincia_de_destino_final'),
      value: null,
      options: [],
      cols: 6,
      listenSelect: true,
    },
    {
      key: 'destinationCity',
      title: t('nueva_operacion.inputs_step_4_ar.localidad_de_destino_final'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_ar.localidad_de_destino_final'),
      value: null,
      cols: 6,
      options: [],
      disabled: true,
    },
    {
      key: 'stops',
      title: t('nueva_operacion.inputs_step_4_ar.paradas_intermedias'),
      selectLabel: null,
      type: 'select',
      placeholder: t('nueva_operacion.inputs_step_4_ar.paradas_intermedias_placeholder'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      options: [
        { nombre: 'Si', id: 1 },
        { nombre: 'No', id: 0 },
      ],
      listenSelect: true,
    },
    {
      key: 'stop1',
      title: t('nueva_operacion.inputs_step_4_ar.parada_1'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.parada_1'),
      value: null,
      cols: 6,
      disabled: true,
      validations: {
        rules: {
          required: false,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'stop2',
      title: t('nueva_operacion.inputs_step_4_ar.parada_2'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.parada_2'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'stop3',
      title: t('nueva_operacion.inputs_step_4_ar.parada_3'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.parada_3'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'startDate',
      title: t('nueva_operacion.inputs_step_4_ar.fecha_inicio_viaje'),
      type: 'date',
      placeholder: t('nueva_operacion.inputs_step_4_ar.fecha_inicio_viaje'),
      value: null,
      cols: 6,
      min: today(),
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'startTime',
      title: t('nueva_operacion.inputs_step_4_ar.hora_inicio_viaje'),
      type: 'time',
      placeholder: t('nueva_operacion.inputs_step_4_ar.hora_inicio_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      listenFocus: true,
    },
    {
      key: 'endDate',
      title: t('nueva_operacion.inputs_step_4_ar.fecha_fin_viaje'),
      type: 'date',
      placeholder: t('nueva_operacion.inputs_step_4_ar.fecha_fin_viaje'),
      value: null,
      cols: 6,
      min: today(),
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'endTime',
      title: t('nueva_operacion.inputs_step_4_ar.hora_fin_viaje'),
      type: 'time',
      placeholder: t('nueva_operacion.inputs_step_4_ar.hora_fin_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'documentDescription',
      title: t('nueva_operacion.inputs_step_4_ar.documentos_del_viaje'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.documentos_del_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'document',
      title: t('nueva_operacion.inputs_step_4_ar.adjuntar_documentos'),
      type: 'file',
      placeholder: t('nueva_operacion.inputs_step_4_ar.adjuntar_documentos'),
      value: null,
      cols: 6,
      hidden: false,
    },
    {
      key: 'truckPlate',
      title: t('nueva_operacion.inputs_step_4_ar.placa_tractor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.placa_tractor'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'box-trailer',
      title: t('nueva_operacion.inputs_step_4_ar.caja_de_carga'),
      selectLabel: null,
      type: 'select',
      placeholder: t('nueva_operacion.inputs_step_4_ar.caja_de_carga'),
      value: null,
      cols: 4,
      options: [
        { nombre: 'Si', id: 1 },
        { nombre: 'No', id: 0 },
      ],
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      hidden: false,
      listenSelect: true,
    },
    {
      key: 'trailerPlate',
      title: t('nueva_operacion.inputs_step_4_ar.placa_caja'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.placa_caja'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          required: false,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      disabled: true,
    },
    {
      key: 'driverName',
      title: t('nueva_operacion.inputs_step_4_ar.nombre_del_conductor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.nombre_del_conductor'),
      value: null,
      cols: 12,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'driverCellphone',
      title: t('nueva_operacion.inputs_step_4_ar.movil_del_conductor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_ar.movil_del_conductor'),
      value: null,
      cols: 12,
      validations: {
        rules: {
          required: true,
          max: 12,
          min: 8,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'driverEmail',
      title: t('nueva_operacion.inputs_step_4_ar.email_del_conductor'),
      type: 'email',
      placeholder: t('nueva_operacion.inputs_step_4_ar.email_del_conductor'),
      value: null,
      cols: 12,
      validations: {
        rules: {
          email: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      hidden: false,
    },
  ];
};

export const inputsStep4CL = () => {
  const t = i18n.global.t;

  return[
    {
      key: 'assetId',
      title: t('nueva_operacion.inputs_step_4_cl.tipo_de_mercancia'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_cl.tipo_de_mercancia'),
      value: null,
      cols: 12,
      disabled: true,
    },
    {
      key: 'indemnificationLimit',
      title: t('nueva_operacion.inputs_step_4_cl.limite_de_indemnizacion'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_cl.limite_de_indemnizacion'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'indemnificationLimit-calc',
      title: t('nueva_operacion.inputs_step_4_cl.precio'),
      type: 'text',
      value: null,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_cl.precio_mas_iva'),
      disabled: true,
      cols: 6,
    },
    {
      key: 'originRegion',
      title: t('nueva_operacion.inputs_step_4_cl.region_de_origen'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      options: null,
      placeholder: t('nueva_operacion.inputs_step_4_cl.region_de_origen'),
      value: null,
      cols: 6,
      listenSelect: true,
    },
    {
      key: 'originComuna',
      title: t('nueva_operacion.inputs_step_4_cl.comuna_de_origen'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_cl.comuna_de_origen'),
      value: null,
      cols: 6,
      options: [],
      disabled: true,
    },
    {
      key: 'destinationRegion',
      title: t('nueva_operacion.inputs_step_4_cl.region_de_destino_final'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_cl.region_de_destino_final'),
      value: null,
      options: null,
      cols: 6,
      listenSelect: true,
    },
    {
      key: 'destinationComuna',
      title: t('nueva_operacion.inputs_step_4_cl.comuna_de_destino_final'),
      type: 'select',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_cl.comuna_de_destino_final'),
      value: null,
      cols: 6,
      options: [],
      disabled: true,
    },
    {
      key: 'stops',
      title: t('nueva_operacion.inputs_step_4_cl.paradas_intermedias'),
      selectLabel: null,
      type: 'select',
      placeholder: t('nueva_operacion.inputs_step_4_cl.paradas_intermedias_placeholder'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      options: [
        { nombre: 'Si', id: 1 },
        { nombre: 'No', id: 0 },
      ],
      listenSelect: true,
    },
    {
      key: 'stop1',
      title: t('nueva_operacion.inputs_step_4_cl.parada_1'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.parada_1'),
      value: null,
      cols: 6,
      disabled: true,
      validations: {
        rules: {
          required: false,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'stop2',
      title: t('nueva_operacion.inputs_step_4_cl.parada_2'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.parada_2'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'stop3',
      title: t('nueva_operacion.inputs_step_4_cl.parada_3'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.parada_3'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'startDate',
      title: t('nueva_operacion.inputs_step_4_cl.fecha_inicio_viaje'),
      type: 'datetime',
      enableTimePicker: false,
      format: 'dd/MM/yyyy',
      modelType: 'yyyy-MM-dd',
      min: new Date(),
      autoApply: true,
      placeholder: t('nueva_operacion.inputs_step_4_cl.fecha_inicio_viaje'),
      value: null,
      cols: 6,
      listenChange: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'startTime',
      title: t('nueva_operacion.inputs_step_4_cl.hora_inicio_viaje'),
      type: 'time',
      placeholder: t('nueva_operacion.inputs_step_4_cl.hora_inicio_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      listenFocus: true,
    },
    {
      key: 'endDate',
      title: t('nueva_operacion.inputs_step_4_cl.fecha_fin_viaje'),
      type: 'datetime',
      placeholder: 'Fecha de fin',
      value: null,
      cols: 6,
      enableTimePicker: false,
      format: 'dd/MM/yyyy',
      modelType: 'yyyy-MM-dd',
      min: new Date(),
      disabled: true,
      autoApply: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'endTime',
      title: t('nueva_operacion.inputs_step_4_cl.hora_fin_viaje'),
      type: 'time',
      placeholder: t('nueva_operacion.inputs_step_4_cl.hora_fin_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'documentDescription',
      title: t('nueva_operacion.inputs_step_4_cl.documentos_del_viaje'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.documentos_del_viaje'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'document',
      title: t('nueva_operacion.inputs_step_4_cl.adjuntar_documentos'),
      type: 'file',
      placeholder: t('nueva_operacion.inputs_step_4_cl.adjuntar_documentos'),
      value: null,
      cols: 6,
      hidden: false,
    },
    {
      key: 'truckPlate',
      title: t('nueva_operacion.inputs_step_4_cl.placa_tractor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.placa_tractor'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'box-trailer',
      title: t('nueva_operacion.inputs_step_4_cl.caja_de_carga'),
      selectLabel: null,
      type: 'select',
      placeholder: t('nueva_operacion.inputs_step_4_cl.caja_de_carga'),
      value: null,
      cols: 4,
      options: [
        { nombre: 'Si', id: 1 },
        { nombre: 'No', id: 0 },
      ],
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      hidden: false,
      listenSelect: true,
    },
    {
      key: 'trailerPlate',
      title: t('nueva_operacion.inputs_step_4_cl.placa_caja'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.placa_caja'),
      value: null,
      cols: 4,
      validations: {
        rules: {
          required: false,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      disabled: true,
    },
    {
      key: 'driverName',
      title: t('nueva_operacion.inputs_step_4_cl.nombre_del_conductor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.nombre_del_conductor'),
      value: null,
      cols: 12,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'driverCellphone',
      title: t('nueva_operacion.inputs_step_4_cl.movil_del_conductor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_cl.movil_del_conductor'),
      value: null,
      cols: 12,
      validations: {
        rules: {
          required: true,
          max: 12,
          min: 8,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'driverEmail',
      title: t('nueva_operacion.inputs_step_4_cl.email_del_conductor'),
      type: 'email',
      placeholder: t('nueva_operacion.inputs_step_4_cl.email_del_conductor'),
      value: null,
      cols: 12,
      validations: {
        rules: {
          email: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      hidden: false,
    },
  ];
}

export const inputsStep4Paqueteria = () => {
 const t = i18n.global.t;

 return [
    {
      key: 'indemnificationLimit',
      title: t('nueva_operacion.inputs_step_4_paqueteria.limite_de_indemnizacion'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_paqueteria.limite_de_indemnizacion'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'indemnificationLimit-calc',
      title: t('nueva_operacion.inputs_step_4_paqueteria.precio'),
      type: 'text',
      value: null,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_paqueteria.precio_mas_iva'),
      disabled: true,
      cols: 6,
    },
    {
      key: 'packageNumbers',
      title: t('nueva_operacion.inputs_step_4_paqueteria.numero_de_guias_separados_por_comas'),
      type: 'textarea',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_paqueteria.numero_de_guias_separados_por_comas_placeholder'),
      cols: 12,
    },
  ];
}

export const inputsStep4Maritimo = () => {
  const t = i18n.global.t;

  return [
    { slot: true, key: 'title' },
    {
      key: 'assetId',
      title: t('nueva_operacion.inputs_step_4_maritimo.tipo_de_mercancia'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.tipo_de_mercancia'),
      value: null,
      cols: 12,
      disabled: true,
    },
    {
      key: 'indemnificationLimit',
      title: t('nueva_operacion.inputs_step_4_maritimo.limite_de_indemnizacion'),
      type: 'number',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.limite_de_indemnizacion'),
      value: null,
      cols: 6,
      disabled: true,
    },
    {
      key: 'indemnificationLimit-calc',
      title: t('nueva_operacion.inputs_step_4_maritimo.precio'),
      type: 'text',
      value: null,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.precio_mas_iva'),
      disabled: true,
      cols: 6,
    },
    {
      key: 'shippingCompany',
      title: t('nueva_operacion.inputs_step_4_maritimo.naviera'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.naviera'),
      value: null,
      cols: 12,
      listenChange: true,
    },
    {
      key: 'travelStartDate',
      title: t('nueva_operacion.inputs_step_4_maritimo.fecha_de_salida'),
      type: 'datetime',
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.fecha_de_inicio'),
      value: null,
      enableTimePicker: false,
      format: 'dd/MM/yyyy',
      modelType: 'yyyy-MM-dd',
      min: new Date(),
      autoApply: true,
      cols: 4,
      listenChange: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'countryDeparture',
      title: t('nueva_operacion.inputs_step_4_maritimo.pais_de_salida'),
      selectLabel: null,
      type: 'select',
      options: [],
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.pais_de_salida'),
      value: null,
      cols: 4,
    },
    {
      key: 'portDeparture',
      title: t('nueva_operacion.inputs_step_4_maritimo.puerto_de_salida'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.puerto_de_salida'),
      value: null,
      cols: 4,
      listenChange: true,
    },
    {
      key: 'travelEndDate',
      title: t('nueva_operacion.inputs_step_4_maritimo.fecha_estimada_de_llegada_a_puerto'),
      type: 'datetime',
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.fecha_de_fin'),
      value: null,
      cols: 4,
      enableTimePicker: false,
      format: 'dd/MM/yyyy',
      modelType: 'yyyy-MM-dd',
      min: new Date(),
      disabled: true,
      autoApply: true,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
    {
      key: 'countryArrival',
      title: t('nueva_operacion.inputs_step_4_maritimo.pais_de_llegada'),
      selectLabel: null,
      type: 'select',
      options: [],
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.pais_de_llegada'),
      value: null,
      cols: 4,
    },
    {
      key: 'portArrival',
      title: t('nueva_operacion.inputs_step_4_maritimo.puerto_de_arribo'),
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.puerto_de_arribo'),
      value: null,
      cols: 4,
      listenChange: true,
    },
    {
      key: 'containerType',
      title: t('nueva_operacion.inputs_step_4_maritimo.tipo_de_contenedor'),
      selectLabel: null,
      type: 'select',
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.tipo_de_contenedor'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      options: [],
    },
    {
      key: 'containerNumber',
      title: t('nueva_operacion.inputs_step_4_maritimo.numero_de_contenedor'),
      type: 'text',
      placeholder: t('nueva_operacion.inputs_step_4_maritimo.numero_de_contenedor'),
      value: null,
      cols: 6,
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
    },
  ];
}